import React from "react";
import styles from "./index.module.scss";
import MetricsTable from "./MetricsTable";

const AllMetrics = () => {
  return (
    <div className={styles.wrapper} id="all-metrics">
      <h2 className="subheader-medium">All metrics</h2>
      <MetricsTable />
    </div>
  );
};

export default AllMetrics;
